// Autogenerated file
import Header from './Header.json';

export default {
  ...Header,
};
